import { render, staticRenderFns } from "./DiagnosticSelectPayment.vue?vue&type=template&id=643b9f47&"
import script from "./DiagnosticSelectPayment.vue?vue&type=script&lang=js&"
export * from "./DiagnosticSelectPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports